module.exports = __webpack_public_path__ + "media/newstyle/images/word-file-icon-9debed9173adac067779ac9509df94e1.svg";